export default (state = [], action) => {
    switch (action.type) {
        case 'ADD_CHOICE':
            return [...new Set([
                ...state,
                action.id
            ])];
        case 'CLEAR_CHOICE':
            return [];
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/choiceReducers.js